export const TRIP_QUOTE_START = 'TRIP_QUOTE_START';
export const TRIP_QUOTE_SUCCESS = 'PLANS_SUCCESS';
export const TRIP_QUOTE_FAIL = 'TRIP_QUOTE_FAIL';
export const TRIP_QUOTE_FINISH = 'TRIP_QUOTE_FINISH';

export const TRIP_PLANS_SET = 'TRIP_PLANS_SET';
export const PLAN_TRIP_SELECTED = "PLAN_TRIP_SELECTED";
export const TRIP_FRACTIONATION = "TRIP_FRACTIONATION";

export const SET_TITULAR_DATA = "SET_TITULAR_DATA";
export const SET_PASSENGERS = "SET_PASSENGERS";
export const UPDATE_PASSENGERS = "UPDATE_PASSENGERS";
export const SET_TRIP_DETAILS = "SET_TRIP_DETAILS";
export const SET_TRIP_COUNT_PASSENGERS = "SET_TRIP_COUNT_PASSENGERS";
export const SET_TRIP_FORM = "SET_TRIP_FORM";

export const SET_FECHA_IDA = "SET_FECHA_IDA";
export const SET_FECHA_VUELTA = "SET_FECHA_VUELTA";

export const TRIP_DESTINATIONS_SUCCESS = 'TRIP_DESTINATIONS_SUCCESS';
export const SET_USER_LEAD = 'SET_USE_LEAD';
export const CLEAR_PASSENGERS_DATA = 'CLEAR_PASSENGERS_DATA';
export const CLEAR_TITULAR_DATA = 'CLEAR_TITULAR_DATA';

export const SET_TRIP_EMBEDDED = 'SET_TRIP_EMBEDDED';
export const SET_URL_EMBEDDED = 'SET_URL_EMBEDDED';

export const SET_MESSAGE_EMBEDDED = 'SET_MESSAGE_EMBEDDED';

export const SET_VALID_INITIAL_LEAD = 'SET_VALID_INITIAL_LEAD';